"use client";

import { useIsDark } from "@/context/ThemeContext";
import { twMerge } from "tailwind-merge";

export default function SectionHeader({
  title,
  description,
  as: Heading = "h1",
  wrapperClassName = "",
  titleClassName = "",
  descriptionClassName = "",
  uppercase = true,
}) {
  const isDark = useIsDark();

  const wrapperClasses = twMerge(
    "relative flex flex-col items-center justify-center mt-8 mb-8 md:mt-14 md:mb-14 xl:mt-20 xl:mb-20 z-10",
    wrapperClassName
  );

  const headingClasses = twMerge(
    "font-alexandria font-semibold text-[22px] sm:text-[24px] md:text-[28px] lg:text-[32px] xl:text-[35px] 3xl:text-[40px] text-center text-foreground",
    uppercase ? "uppercase" : "",
    titleClassName
  );

  const paragraphClasses = twMerge(
    `font-manrope font-medium text-center xl:max-w-[1240px] text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] 3xl:text-[22px] leading-[27px] mt-4 xl:mt-10 ${
      isDark ? "text-[#FFFFFF]" : "text-[#5A5A6E]"
    }`,
    descriptionClassName
  );

  return (
    <div className={wrapperClasses}>
      {title ? <Heading className={headingClasses}>{title}</Heading> : null}
      {description ? <p className={paragraphClasses}>{description}</p> : null}
    </div>
  );
}
